<template>
  <v-row dense>
    <v-col cols="12" sm="6" v-for="column in columns" :key="`item-id-${column.id}`">
      <v-sheet class="column-toggle" outlined rounded @click="$emit('toggle', column)">
        {{ column.columnAdjusterText ?? column.text }}
        <v-icon :color="column.visible ? 'success' : 'black'" class="float-right">
          {{ column.visible ? 'mdi-checkbox-marked' : 'mdi-checkbox-blank-outline' }}
        </v-icon>
      </v-sheet>
    </v-col>
  </v-row>
</template>

<script>
export default {
  name: 'ColumnToggleGrid',

  props: {
    columns: {
      type: Array,
      required: true
    }
  }
}
</script>

<style scoped>
.column-toggle {
  font-size: 18px;
  padding: 8px;
  cursor: pointer;
  user-select: none;
}
</style>
